var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConectionAccepted = function SvgConectionAccepted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.1111H5.95013C4.69412 12.1111 4.06611 12.1111 3.55509 12.2642C2.40453 12.6089 1.50416 13.4982 1.15514 14.6345C1.00012 15.1392 1.00012 15.7595 1.00012 17M13.6001 14.3333L14.838 15.5559C15.035 15.7505 15.1335 15.8478 15.2468 15.8843C15.3465 15.9164 15.4538 15.9164 15.5534 15.8843C15.6668 15.8478 15.7653 15.7505 15.9623 15.5559L19.0001 12.5556M12.2501 5C12.2501 7.20914 10.4369 9 8.20012 9C5.96337 9 4.15012 7.20914 4.15012 5C4.15012 2.79086 5.96337 1 8.20012 1C10.4369 1 12.2501 2.79086 12.2501 5Z",
    stroke: "#1EAFA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConectionAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conectionAccepted.fbe54fdf.svg";
export { ForwardRef as ReactComponent };